module.exports = __webpack_public_path__ + "img/PS-EquipoDeSeguridad.257e0270.png";